export default __webpack_public_path__ + "static/media/service_img.e472fc44.png";